// extracted by mini-css-extract-plugin
export default {"empty_block":"style_empty_block__Ye4co","title":"style_title__k0de4"};